import { render, staticRenderFns } from "./SendInvite.vue?vue&type=template&id=601d50a4&scoped=true"
import script from "./SendInvite.vue?vue&type=script&lang=js"
export * from "./SendInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d50a4",
  null
  
)

export default component.exports